import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactInfo = () => {
  const contactDetails = [
    {
      icon: 'Mail',
      title: 'Email Support',
      content: 'support@workfolio.no',
      description: 'We typically respond within 24 hours',
      action: 'mailto:support@workfolio.no'
    },
    {
      icon: 'MapPin',
      title: 'Office Address',
      content: 'Storgata 15, 0155 Oslo, Norway',
      description: 'Visit us during business hours',
      action: 'https://maps.google.com/?q=Storgata+15,+0155+Oslo,+Norway'
    },
    {
      icon: 'Clock',
      title: 'Business Hours',
      content: 'Monday - Friday: 9:00 - 17:00',
      description: 'Norwegian time (CET/CEST)',
      action: null
    },
    {
      icon: 'Phone',
      title: 'Phone Support',
      content: '+47 22 12 34 56',
      description: 'Available during business hours',
      action: 'tel:+4722123456'
    }
  ];

  const supportCategories = [
    {
      title: 'General Questions',
      description: 'Information about our platform and services',
      responseTime: '< 24 hours'
    },
    {
      title: 'Technical Support',
      description: 'Help with account issues and technical problems',
      responseTime: '< 12 hours'
    },
    {
      title: 'Business Partnerships',
      description: 'Collaboration opportunities and enterprise solutions',
      responseTime: '< 48 hours'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Contact Information */}
      <div className="bg-card rounded-2xl shadow-elevation p-8">
        <h2 className="text-2xl font-semibold text-foreground mb-6">
          Get in Touch
        </h2>
        
        <div className="space-y-6">
          {contactDetails?.map((detail, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
                <Icon name={detail?.icon} size={20} className="text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-foreground mb-1">
                  {detail?.title}
                </h3>
                {detail?.action ? (
                  <a
                    href={detail?.action}
                    target={detail?.action?.startsWith('http') ? '_blank' : undefined}
                    rel={detail?.action?.startsWith('http') ? 'noopener noreferrer' : undefined}
                    className="text-primary hover:text-primary/80 transition-colors font-medium"
                  >
                    {detail?.content}
                  </a>
                ) : (
                  <div className="text-foreground font-medium">
                    {detail?.content}
                  </div>
                )}
                <p className="text-sm text-muted-foreground mt-1">
                  {detail?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Support Categories */}
      <div className="bg-card rounded-2xl shadow-elevation p-8">
        <h3 className="text-xl font-semibold text-foreground mb-6">
          Support Categories
        </h3>
        
        <div className="space-y-4">
          {supportCategories?.map((category, index) => (
            <div key={index} className="border border-border rounded-lg p-4">
              <div className="flex items-center justify-between mb-2">
                <h4 className="font-medium text-foreground">
                  {category?.title}
                </h4>
                <span className="text-xs bg-success/10 text-success px-2 py-1 rounded-full">
                  {category?.responseTime}
                </span>
              </div>
              <p className="text-sm text-muted-foreground">
                {category?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
      {/* FAQ Link */}
      <div className="bg-gradient-to-r from-primary/5 to-accent/5 rounded-2xl p-6 border border-primary/20">
        <div className="flex items-center space-x-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
            <Icon name="HelpCircle" size={20} className="text-primary" />
          </div>
          <div className="flex-1">
            <h3 className="font-medium text-foreground mb-1">
              Need Quick Answers?
            </h3>
            <p className="text-sm text-muted-foreground mb-3">
              Check our FAQ section for immediate answers to common questions.
            </p>
            <a
              href="/homepage#faq"
              className="inline-flex items-center space-x-2 text-primary hover:text-primary/80 transition-colors text-sm font-medium"
            >
              <span>Browse FAQ</span>
              <Icon name="ArrowRight" size={16} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;